import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { logoImage } from '../assets/images';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = React.useRef(0);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 20);
      // Hide on scroll down (after 80px), show on scroll up
      if (y > 80) {
        setHidden(y > lastScrollY.current);
      } else {
        setHidden(false);
      }
      lastScrollY.current = y;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}${hidden ? ' header--hidden' : ''}`}>


      {/* Main nav */}
      <div className="header-main">
        <div className="header-container">
          <Link to="/" className="logo" aria-label="Fast Track Driving School Home">
            <img src={logoImage} alt="Fast Track Driving School UK" className="logo-image" />
          </Link>

          <nav className={`nav${mobileMenuOpen ? ' nav-open' : ''}`} aria-label="Main navigation">
            <button
              className="nav-close-btn"
              onClick={() => setMobileMenuOpen(false)}
              aria-label="Close menu"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
            <Link to="/" className={`nav-link${isActive('/') ? ' active' : ''}`}>Home</Link>
            <Link to="/pricing" className={`nav-link${isActive('/pricing') ? ' active' : ''}`}>Pricing</Link>
            <Link to="/book-lesson" className={`nav-link${isActive('/book-lesson') ? ' active' : ''}`}>Book a Lesson</Link>
            <Link to="/become-instructor" className={`nav-link${isActive('/become-instructor') ? ' active' : ''}`}>Become an Instructor</Link>
            <Link to="/about" className={`nav-link${isActive('/about') ? ' active' : ''}`}>About Us</Link>
            <Link to="/contact" className={`nav-link${isActive('/contact') ? ' active' : ''}`}>Contact</Link>
            <Link to="/book-lesson" className="nav-mobile-cta">Book Now →</Link>
          </nav>
          {/* Backdrop — tapping outside closes menu */}
          {mobileMenuOpen && <div className="nav-backdrop" onClick={() => setMobileMenuOpen(false)} aria-hidden="true" />}

          <div className="header-actions">
            <Link to="/book-lesson" className="btn-book-now">
              Book Now
            </Link>
            <button
              className={`mobile-menu-toggle${mobileMenuOpen ? ' open' : ''}`}
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
              aria-expanded={mobileMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
